import apiClient from "../../../apiClient";
import { DepartmentAccess } from "./configTypes";

export default function useDepartmentAccess() {
    const getAccess = async (departmentId: number) => {
        const res = await apiClient.get(`/inventory-dev/departments/${departmentId}/access`);
        return res.data as DepartmentAccess;
    };

    const setAccess = async (departmentId: number, userIds: string[]) => {
        const res = await apiClient.put(`/inventory-dev/departments/${departmentId}/access`, { userIds });
        return res.data as DepartmentAccess & { added: string[]; removed: string[] };
    };

    return { getAccess, setAccess };
}
